/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Event_Gap_TooltipInputs */



/**
* | output |
* | --- |
* | "The minimum and maximum duration in frames between events" |
*
* @param {Style_Guide_Manager_Event_Gap_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_event_gap_tooltip = /** @type {((inputs?: Style_Guide_Manager_Event_Gap_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Event_Gap_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Duree minimale et maximale en frames entre les evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die minimale und maximale Dauer in Frames zwischen Ereignissen")
	if (locale === "it") return /** @type {LocalizedString} */ ("La durata minima e massima in fotogrammi tra gli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная и максимальная продолжительность в кадрах между событиями.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La duración mínima y máxima en cuadros entre eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件之间以帧为单位的最小和最大持续时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント間のフレームの最小および最大期間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं के बीच फ्रेम में न्यूनतम और अधिकतम अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A duração mínima e máxima em frames entre eventos")
	return /** @type {LocalizedString} */ ("The minimum and maximum duration in frames between events")
});